<template>
    <div>
        <gofix-card title="Signature Completed" class="mb-0" classHeader="mb-13" classContent="mb-0" v-if="Item.signatures.length">
            <b-row no-gutters class="mb-15">
                <template v-for="(item, index) in Item.signatures">
                    <b-col md="4" class="pr-15" :key='index'>
                        <gofix-card class="pd-20" classContent="pd-0">
                            <b-row>
                                <b-col md="6">
                                    <gofix-text-field label="User" oneline>{{ item.user && item.user.name ? item.user.name : '-' }}</gofix-text-field>
                                </b-col>
                                <b-col md="6">
                                    <gofix-text-field label="Signature" class="photosThumb mt-0" classInner="justify-content-end" oneline>
                                        <template v-if="item.attachments">
                                            <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb signature_v2">
                                                        <template v-for="(item_image, key) in images">
                                                            <li :key="key">
                                                                <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif">
                                                            </li>
                                                        </template>
                                                    </ul>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                    </b-col>
                </template>
            </b-row>
        </gofix-card>
        <gofix-card title="Signature Endorsed" class="mt-13" classHeader="mb-13" classContent="mb-0" v-if="Item.signatures_spe.length">
            <b-row no-gutters class="mb-15">
                <template v-for="(item, index) in Item.signatures_spe">
                    <b-col md="4" class="pr-15" :key='index'>
                        <gofix-card class="pd-20" classContent="pd-0">
                            <b-row>
                                <b-col md="6">
                                    <gofix-text-field label="User" oneline>{{ item.user && item.user.name ? item.user.name : '-' }}</gofix-text-field>
                                </b-col>
                                <b-col md="6">
                                    <gofix-text-field label="Signature" class="photosThumb mt-0" classInner="justify-content-end" oneline>
                                        <template v-if="item.attachments">
                                            <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb signature_v2">
                                                        <template v-for="(item_image, key) in images">
                                                            <li :key="key">
                                                                <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif">
                                                            </li>
                                                        </template>
                                                    </ul>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                    </b-col>
                </template>
            </b-row>
        </gofix-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    export default {
        name: 'check-list-signature',
        components: {
            ViewerImage
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters({
                Item: "JobController/Item"
            }),
        },
        created() {},
        methods: {}
    }
</script>
